import { render, staticRenderFns } from "./CourseDirectionDetail.vue?vue&type=template&id=e1a22de6&scoped=true&"
import script from "./CourseDirectionDetail.vue?vue&type=script&lang=js&"
export * from "./CourseDirectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseDirectionDetail.vue?vue&type=style&index=0&id=e1a22de6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a22de6",
  null
  
)

export default component.exports